import './Text.less';
export { default as Text } from './Text.js';
export { default } from './Text.js';